import React, { useContext, useMemo } from "react";
import { Link } from "react-router-dom";
import { files } from "../configs";
import { Context } from "../GlobalContext";
import "../global/pages.css";
import "./Intro.css";

const Intro = ({ match }) => {
  const { token, surveyList, reqInfoPages } = useContext(Context);

  const surveyNumber = useMemo(
    () => parseInt(match.params.surveyNumber),
    [match.params.surveyNumber]
  );

  const surveyType = useMemo(
    () => match.params.surveyType,
    [match.params.surveyType]
  );

  const isFirstSurvey = useMemo(() => surveyNumber === 0, [surveyNumber]);

  const prevSurveyNumber = useMemo(
    () => (!isFirstSurvey ? parseInt(surveyNumber - 1) : null),
    [isFirstSurvey, surveyNumber]
  );

  const prevSurveyType = useMemo(
    () =>
      !isFirstSurvey && surveyList[prevSurveyNumber].surveyType === "아동척도"
        ? "a"
        : !isFirstSurvey &&
          surveyList[prevSurveyNumber].surveyType === "영향평가"
        ? "b"
        : !isFirstSurvey &&
          surveyList[prevSurveyNumber].surveyType === "추가문항"
        ? "c"
        : null,
    [isFirstSurvey, surveyList, prevSurveyNumber]
  );

  return (
    <div className="container" id={`intro__container__${surveyType}`}>
      <div className="intro-inner">
        <img
          src={`${files}/kids-${surveyType}.svg`}
          alt={surveyList[surveyNumber].name}
          className="intro-img"
        />
        <h1>
          {surveyList[surveyNumber].name
            .replace("아동척도", "아동친화도시 조사\nPART1")
            .replace("도시척도", "아동친화도시 조사\nPART2")}
        </h1>
        <img
          className="intro-inst-img"
          src={surveyList[surveyNumber].introduction}
          alt="아동이 살기 좋은 우리 동네 만들기"
        />
      </div>
      <div className="link-buttons">
        <Link
          to={
            prevSurveyType !== null
              ? `/token/${token}/separator/${prevSurveyType}/${prevSurveyNumber}/0/0`
              : reqInfoPages.needsInfoTwo
              ? `/token/${token}/info-2`
              : reqInfoPages.needsInfoOne
              ? `/token/${token}/info-1`
              : reqInfoPages.needsAgree
              ? `/token/${token}/confirm`
              : !reqInfoPages.needsInfoTwo &&
                !reqInfoPages.needsInfoOne &&
                !reqInfoPages.needsAgree
              ? `/token/${token}/greeting`
              : null
          }
          className="link-btn"
          alt="뒤로 버튼"
        >
          뒤로
        </Link>
        <Link
          to={`/token/${token}/survey/${match.params.surveyType}/${match.params.surveyNumber}/0/0`}
          className="link-btn"
          alt="다음으로 버튼"
        >
          다음으로
        </Link>
      </div>
    </div>
  );
};

export default Intro;
